import { render, staticRenderFns } from "./descriptioneditmodal.vue.html?vue&type=template&id=4d3ca1c0"
import script from "./descriptioneditmodal.controller?vue&type=script&lang=js&external"
export * from "./descriptioneditmodal.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports